/// <reference types="vite-plugin-svgr/client" />

import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import { Grid, Paper, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { IModule } from '../../@types'
import { THEME } from '../../global'
import { SourceLevelBar } from '../source-level-bar'

interface IProps {
  isActive?: boolean
  value: number
  data: IModule
}

export function HomePageModule({ data, isActive = false, value }: IProps) {
  const navigate = useNavigate()
  const [watchPercent, setWatchPercent] = useState('0')
  const iconURL = isActive ? '/trabalho-active.png' : '/trabalho-disabled.png'
  const borderColor =
    isActive && value !== 100 ? THEME.colors.primary : THEME.colors.tertiary
  const textColor = isActive ? '#fff' : THEME.colors.disabled

  useEffect(() => {
    data.watchPercent &&
      setWatchPercent(data.watchPercent.toLocaleString().split('.')[0])
  }, [data])

  return (
    <Grid item xs={2} sm={4} md={4}>
      <a
        onClick={() => {
          isActive &&
            navigate(`lessons/${data.id}/${data.name}/${watchPercent}`)
        }}
      >
        <Paper
          sx={{
            display: 'flex',
            position: 'relative',
            flexDirection: 'column',
            overflow: 'hidden',
            bgcolor: 'transparent',
            border: 4,
            width: '100%',
            height: 185,
            gap: 0.5,
            borderRadius: 4,
            padding: 2,
            borderColor,
            alignItems: 'center',
            justifyContent: 'end',
          }}
        >
          <ModuleStatusIcon isActive={isActive} value={value} />

          <img src={iconURL} style={{ width: '60%' }} alt="icon" />
          <Typography
            sx={{
              fontSize: 15,
              textAlign: 'center',
              fontWeight: 700,
              pb: 0.5,
              pt: 0.5,
            }}
            color={textColor}
          >
            {data.name}
          </Typography>
          <SourceLevelBar value={value} barHeight={4} sx={{ width: '100%' }} />
        </Paper>
      </a>
    </Grid>
  )
}

function ModuleStatusIcon({
  value,
  isActive,
}: {
  value?: number
  isActive?: boolean
}) {
  const moduleStatusColor =
    value === 100 ? THEME.colors.success : THEME.colors.disabled

  return (
    <>
      {isActive ? (
        <CheckCircleIcon
          sx={{
            color: moduleStatusColor,
            position: 'absolute',
            top: 6,
            left: 6,
          }}
        />
      ) : (
        <LockOutlinedIcon
          sx={{
            color: THEME.colors.disabled,
            position: 'absolute',
            top: 6,
            left: 6,
          }}
        />
      )}
    </>
  )
}
